module.exports = __webpack_public_path__ + "static/media/recuperarsenha.d57797ad.png";